
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'


export default {
components: {
XHeader,
Group,
Cell
},
data() {
return {
messageList: []
};
},
created() {
this.$vux.loading.show({
text: "请稍候..."
});

this.$http({
method: "post",
url: "wxexam.ashx?op=LoadPhoneMessageList",
params: {
userId: this.$store.getters.getUserInfo.CusId,
courseId: this.$store.getters.getClassInfo.CourseId,
pageSize: 1000,
pageIndex: 1
}
})
.then(response => {
if (response.status == 200) {
this.messageList = response.data.data;
}
this.$vux.loading.hide();
})
.catch(function(error) {
console.log("error:" + error);
this.$vux.loading.hide();
});
},
methods: {
onMsgData(msg) {
if (msg.istatus == 0) {
this.onReadMsg(msg.imsgid);
}

this.$router.push({
path: "/MessageData",
query: {
id: msg.imsgid
}
});
},
onReadMsg(msgId) {
this.$http({
method: "post",
url: "wxexam.ashx?op=ReadPhoneMessage",
params: {
userId: this.$store.getters.getUserInfo.CusId,
msgId: msgId
}
})
.then(response => {
if (response.status == 200 && response.data.errcode == 0 && msgId == -1) {
this.$vux.toast.text("全部已阅成功", "bottom");
}
})
.catch(function(error) {
console.log("error:" + error);
});
}
}
};



// WEBPACK FOOTER //
// ./src/components/MessageList.vue